import qs from 'qs';
import { network } from 'services/network';

export const getLogicCheckerConfiguration = ({ contractId }: { contractId?: number }) => {
    const querystring = qs.stringify({ contractId }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/getLogicCheckerConfiguration${querystring}`;
    return network.get(url).then((response) => {
        return response.data;
    });
};
